








































































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import Gcolumn from '@/components/Charts/Gcolumn.vue';
import * as api from '@/api';
import * as models from '@/api/models';
import dutyUnit from '@/components/dutyUnit.vue';
import { State } from 'vuex-class';
import { IUserSession } from '@/store/modules/session';

@Component({
  components: { Gcolumn, dutyUnit },
})
export default class Home extends Vue {
  @State(s => s.session.activeSession) currentSession: IUserSession;

  ysyqCount: number = 0;
  todayCount: number = 0;
  yqrbCount: number = 0;
  listData = [];
  pagination = {
    current: 1,
    defaultPageSize: 30,
    showQuickJumper: true,
    total: 0,
    showTotal: () => `总记录数 ${this.pagination.total}`,
  };
  mounted() {
    this.getYq();
    this.getNewestYq();
  }

  async getYq() {
    const result: any = await api.Yq.getSummaryData_GET();
    this.ysyqCount = result.data.ysyqCount;
    this.todayCount = result.data.todayCount;
    this.yqrbCount = result.data.yqrbCount;
  }

  async getNewestYq(page: number = 1) {
    this.pagination.current = page;
    const data: any = await api.Yq.getAll_GET({
      isPositive: this.currentSession.deptName == '共青团广西区委' ? false : null,
      reportState: null,
      eventCategoryId: null,
      keyword: '',
      theme: '',
      publisher: '',
      source: '',
      startPublishTime: null,
      endPublishTime: null,
      startCreationTime: null,
      endCreationTime: null,
      size: 30,
      p: page,
    });
    this.listData = data.data.Items;
    this.pagination.total = data.data.TotalCount ? data.data.TotalCount : 0;
  }
}
